import { Collection } from 'modules/core/lib/mobx-rest'

import CompanyHoliday from 'modules/timeoff/store/models/CompanyHoliday'

class CompanyHolidays extends Collection<CompanyHoliday> {
  get cacheKey(): string {
    return 'companyHolidays'
  }

  model() {
    return CompanyHoliday
  }

  filterByRangeAndLocation(
    locationsIds: number[],
    startAt: moment.Moment,
    endAt: moment.Moment
  ): CompanyHoliday[] {
    return this.filter(
      (holiday) =>
        locationsIds.includes(holiday.attributes.location_id) &&
        holiday.parsedDate.isBetween(startAt, endAt, undefined, '[]')
    )
  }
}

const singleton: CompanyHolidays = new CompanyHolidays()

export const locationHolidays = (locationId: number) => {
  return singleton.filter({
    location_id: locationId,
  })
}

export default singleton
